import { render } from "./LogOut.vue?vue&type=template&id=6fda2750&scoped=true"
import script from "./LogOut.vue?vue&type=script&lang=js"
export * from "./LogOut.vue?vue&type=script&lang=js"

import "./LogOut.vue?vue&type=style&index=0&id=6fda2750&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Melissa\\Desktop\\lifehack\\lifehack\\lifehack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fda2750"]])

export default __exports__